import React from 'react';

const TableSkeleton = ({ columns, rows = 8 }) => {
  return (
    <div className="overflow-x-auto">
      <table className="w-full mt-2 text-sm border-collapse">
        <thead>
          <tr className="border-b">
            {columns.map((col, index) => (
              <th key={index} className="py-2 px-4 border-r last:border-r-0">
                <div className="h-4 w-3/4 sm:w-2/3 md:w-1/2 bg-gray-300 rounded-md animate-pulse mx-auto" />
              </th>
            ))}
          </tr>
        </thead>
        <tbody>
          {Array.from({ length: rows }).map((_, rowIndex) => (
            <tr key={rowIndex}>
              {columns.map((col, colIndex) => (
                <td key={`${colIndex}-${rowIndex}`} className="py-4 px-4 border-r last:border-r-0">
                  <div className="h-6 w-full sm:w-4/5 md:w-3/4 bg-gray-300 rounded-md animate-pulse mx-auto" />
                </td>
              ))}
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  );
};

export default React.memo(TableSkeleton);
